/* eslint-disable react/require-default-props */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import round from 'lodash/round';

import { getMetaTags } from '../../../state/metatags';
import { Product } from '../../../state/product';
import { updateUseAs } from '../../../state/user/userOrgRole';
import { getSecurityProfileProductOptions } from '../../../state/securityProfiles';
import { isOwnerOfAsset } from '../../../utils/assetDetails/isOwnerOfAsset';
import {
  Styling, AmazonRssFeed, VAULT_MEDIA_TYPE, VAULT_VIDEO_TYPE,
} from '../../../constants';
import AssetAccess from './AssetAccess/AssetAccess';
import AssetShares from './AssetShares/component';
import AssetPublishes from './AssetPublishes/component';
import AssetPushToCloud from './AssetPushToCloud/component';
import AssetFieldWrapper from './AssetField/AssetFieldWrapper';
import ConfirmDialog from '../ConfirmDialog';
import { canUploadAdditionalAttachments } from '../../../utils/exchange';
import { selectableProfileNames, unshownSecurityProfileIds } from '../../../utils/assetDetails/securityProfileUpdate';

const InstructionContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${Styling.DEFAULT_SPACING}px;
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 6px ${Styling.DEFAULT_SPACING}px 18px;
`;

const AssetPropertyRow = styled.div`
  display: flex;
  flex-direction: column;
`;

const AssetCategoryTitle = styled.div`
  font-size: 120%;
  font-weight: 400;
  padding: 15px 0 5px;
  text-transform: capitalize;
`;

class AssetInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openConfirmDialog: false,
      confirmCallback: null,
      confirmTitle: '',
      confirmMessage: '',
    };
  }

  async componentDidMount() {
    const {
      isMetaTagsLoaded,
      getMetaTags,
      getSecurityProfileProductOptions,
    } = this.props;

    if (!isMetaTagsLoaded) {
      await getMetaTags();
    }

    getSecurityProfileProductOptions();
  }

  componentDidUpdate(prevProps) {
    const {
      selectedUseAs,
    } = this.props;
    const isUseAsAdded = isEmpty(prevProps.selectedUseAs) && !isEmpty(selectedUseAs);
    const isUseAsChanged = !isEmpty(prevProps.selectedUseAs) && !isEqual(selectedUseAs, prevProps.selectedUseAs);

    if (isUseAsAdded || isUseAsChanged) {
      const {
        updateUseAs,
        allUsers,
        onUseAsUpdate,
      } = this.props;

      updateUseAs(selectedUseAs, allUsers);
      onUseAsUpdate();
    }
  }

  handleConfirm = (title, message, callback) => {
    this.setState({
      openConfirmDialog: true,
      confirmCallback: callback,
      confirmTitle: title,
      confirmMessage: message,
    });
  };

  generateAssetDetails = () => {
    const {
      assetDetails,
      isAssetEditable,
      rawAssetDetails,
      securityProfileIdValueMapping,
      securityProfileProductOptions,
      onFieldChange,
      exchangeSport,
    } = this.props;

    // VV-315: the asset's profiles its Security field can't show - hidden from this user (the
    // Film Room group, for anyone but a super admin) or not among the options it offers. The
    // field saves by name, so these would be dropped on save; it is handed them to keep.
    const hiddenSecurityProfileIds = unshownSecurityProfileIds(
      rawAssetDetails?.securityProfiles,
      securityProfileIdValueMapping,
      selectableProfileNames(securityProfileProductOptions),
    );

    return assetDetails.map((category, index) => {
      const currentCategory = { ...category };
      if (currentCategory.category) {
        const isEditableCategory = currentCategory.tags.find((tag) => tag.isEditable === 2);
        const isDisplayCategory = currentCategory.tags.find((tag) => tag.isEditable !== 0);
        const displayCategory = currentCategory.category.replace(/([A-Z])/g, ' $1').trim();
        if ((isEditableCategory && isAssetEditable) || (isDisplayCategory && !isAssetEditable)) {
          return (
            <Fragment key={`Asset.Details.${index}`}>
              <AssetCategoryTitle
                id={`AssetDetails.AssetInfo.Metadata.Category.${currentCategory.category}`}
              >
                {displayCategory}
              </AssetCategoryTitle>
              {currentCategory.tags.map((tag, index) => {
                const {
                  tagName, dataType, displayName, value, lookupObjectId, isEditable,
                } = tag;
                const { loginAs, useAs } = this.props;
                const role = useAs || loginAs;

                const hasPublishAmazonRssFeedPermission = role.userAccessPermission && role.userAccessPermission.publishAmazonRssFeed;
                const hasAssignSecurityProfilePermission = role.userAccessPermission && role.userAccessPermission.assignSecurityProfile;
                const hasManageOwnershipPermission = role.userAccessPermission && role.userAccessPermission.manageOwnership;

                if (tagName === 'securityProfiles' && (!hasAssignSecurityProfilePermission && !(isOwnerOfAsset(role, rawAssetDetails, securityProfileIdValueMapping)))) return;

                if (tagName === 'owner' && !hasManageOwnershipPermission) return;

                // hide field if isEditable is 0 (hidden)
                if (isEditable === 0) return;

                // hide field if isEditable is 1 (readonly) and in edit mode
                if (isEditable === 1 && isAssetEditable) return;

                // hide amazon rss feeds if the user doesn't have publish access or the asset isn't compatiable
                if ((isAssetEditable && tagName === AmazonRssFeed)
                  && (!hasPublishAmazonRssFeedPermission || !rawAssetDetails.amazonRssCompatible)) return;

                // va-1229 + va-1083
                // exchange assets have readonly video title
                if (isAssetEditable
                  && tagName === 'title'
                  && rawAssetDetails.type === VAULT_MEDIA_TYPE.video
                  && rawAssetDetails.videoType === VAULT_VIDEO_TYPE.Exchange) {
                  return;
                }

                // Hide attachments for sports other than Lacrosse
                if (tagName === 'attachments' && !canUploadAdditionalAttachments(exchangeSport)) return;

                // Only allow photoOrientation for images
                if (tagName === 'photoRotation' && rawAssetDetails.type !== VAULT_MEDIA_TYPE.image) return;

                // VV-226: the comment and its Last Updated line are exchange-only. Keyed off
                // the asset's videoType rather than the selected product, so an exchange asset
                // keeps its comment wherever it is viewed and a vault asset never shows one.
                if ((tagName === 'exchangeComment' || tagName === 'exchangeCommentAt')
                  && rawAssetDetails.videoType !== VAULT_VIDEO_TYPE.Exchange) {
                  return;
                }

                let _value = value;

                const kBytes = 1024;
                const mBytes = kBytes ** 2;
                const gBytes = kBytes ** 3;

                if (tagName === 'fileSize' || tagName === 'sourceFileSize') {
                  if (value >= gBytes) {
                    const toGb = round(value / gBytes, 2);
                    _value = `${toGb.toLocaleString()} GB`;
                  } else if (value >= mBytes) {
                    const toMb = round(value / mBytes, 2);
                    _value = `${toMb.toLocaleString()} MB`;
                  } else {
                    const toKb = round(value / kBytes, 2);
                    _value = `${toKb.toLocaleString()} KB`;
                  }
                } else if (tagName === 'bitrate') {
                  _value = `${value} Kb/s`;
                }

                return (
                  <AssetPropertyRow key={`${tagName}.AssetEditable.${isAssetEditable}`}>
                    <AssetFieldWrapper
                      assetType={rawAssetDetails.type}
                      tagName={tagName}
                      data-asset-detail-tag="something"
                      data-tag={tagName}
                      dataType={dataType}
                      label={displayName}
                      value={typeof value === 'boolean' ? value : _value || ''}
                      data-value={value}
                      lookupObjectId={lookupObjectId}
                      disabled={!isAssetEditable || isEditable !== 2}
                      allowAddRemove
                      // track where to dispatch new value in `assetDetails`
                      track={{
                        category: currentCategory.category,
                        tagsId: tag._id,
                      }}
                      handleChangeCallback={onFieldChange}
                      handleConfirm={this.handleConfirm}
                      keepSecurityProfileIds={hiddenSecurityProfileIds}
                    />
                  </AssetPropertyRow>
                );
              })}
            </Fragment>
          );
        }
      }
    });
  };

  render() {
    const {
      isLoaded,
      isMyVault,
      isExchange,
      rawAssetDetails,
    } = this.props;

    return isLoaded ? (
      <DetailsContainer id="AssetDetails.AssetInfo.Metadata">
        {this.generateAssetDetails()}
        <AssetAccess
          rawAssetDetails={rawAssetDetails}
        />
        <AssetPublishes
          rawAssetDetails={rawAssetDetails}
        />
        {isMyVault && (
          <AssetShares
            rawAssetDetails={rawAssetDetails}
          />
        )}
        {isExchange && (
          <AssetPushToCloud
            rawAssetDetails={rawAssetDetails}
          />
        )}
        <ConfirmDialog
          open={this.state.openConfirmDialog}
          onResult={(r) => {
            this.state.confirmCallback(r.confirmed);
            this.setState({
              openConfirmDialog: false,
              confirmCallback: null,
              confirmTitle: '',
              confirmMessage: '',
            });
          }}
          title={this.state.confirmTitle}
          message={this.state.confirmMessage}
        />
      </DetailsContainer>
    ) : (
      <InstructionContainer id="AssetDetails.AssetInfo.Instruction">
        Select asset to preview.
      </InstructionContainer>
    );
  }
}

AssetInfo.propTypes = {
  isLoaded: PropTypes.bool.isRequired,
  assetDetails: PropTypes.array.isRequired,
  rawAssetDetails: PropTypes.object.isRequired,
  isAssetEditable: PropTypes.bool.isRequired,
  isMetaTagsLoaded: PropTypes.bool.isRequired, // supplied from Redux
  allUsers: PropTypes.array.isRequired, // supplied from Redux
  loginAs: PropTypes.object.isRequired, // supplied from Redux
  useAs: PropTypes.object, // supplied from Redux
  selectedUseAs: PropTypes.object, // supplied from Redux
  isMyVault: PropTypes.bool.isRequired, // supplied from Redux
  isExchange: PropTypes.bool.isRequired, // supplied from Redux
  getMetaTags: PropTypes.func.isRequired, // supplied from Redux
  securityProfileIdValueMapping: PropTypes.array.isRequired, // supplied from Redux
  securityProfileProductOptions: PropTypes.array.isRequired, // supplied from Redux
  updateUseAs: PropTypes.func.isRequired, // supplied from Redux
  exchangeSport: PropTypes.string, // supplied from Redux
  onUseAsUpdate: PropTypes.func,
  getSecurityProfileProductOptions: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isMetaTagsLoaded: state.metatags?.isLoaded ?? false,
  loginAs: state.user?.userOrgRole?.loginAs,
  useAs: state.user?.userOrgRole?.useAs,
  allUsers: state.user?.userOrgRole?.users ?? [],
  securityProfileIdValueMapping: state.securityProfiles?.idValueMapping ?? [],
  securityProfileProductOptions: state.securityProfiles?.productOptions ?? [],
  selectedUseAs: state.user?.impersonation?.user,
  isMyVault: state.product?.target === Product.MyVault,
  isExchange: state.product?.target === Product.Exchange,
  exchangeSport: state.exchange?.initExchange?.sport,
});

const mapDispatchToProps = {
  getMetaTags,
  updateUseAs,
  getSecurityProfileProductOptions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetInfo);
